import { Head, Link } from "@inertiajs/react"
import { ArrowLeft } from "lucide-react"

export default function Terms() {
  return (
    <>
      <Head title="Terminos y Condiciones - Catador Pro" />

      <div className="mx-auto max-w-4xl px-6 py-12">
        <Link
          href="/"
          className="text-muted-foreground hover:text-foreground mb-8 flex items-center gap-2 text-sm"
        >
          <ArrowLeft className="h-4 w-4" />
          Volver al inicio
        </Link>

        <h1 className="mb-2 text-4xl font-bold">Terminos y Condiciones</h1>
        <p className="text-muted-foreground mb-8">
          Ultima actualizacion: 4 de abril de 2026
        </p>

        <div className="prose prose-neutral dark:prose-invert max-w-none space-y-8">
          <section>
            <h2 className="text-2xl font-semibold">
              1. Aceptacion de los terminos
            </h2>
            <p>
              Al acceder y utilizar Catador Pro (&quot;la Plataforma&quot;),
              aceptas estos Terminos y Condiciones. Si no estas de acuerdo con
              alguno de estos terminos, no debes utilizar la Plataforma. Nos
              reservamos el derecho de modificar estos terminos en cualquier
              momento, y tu uso continuado constituye aceptacion de los cambios.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold">
              2. Descripcion del servicio
            </h2>
            <p>
              Catador Pro es una plataforma de evaluacion y catacion de cafe que
              permite a profesionales y entusiastas del cafe:
            </p>
            <ul className="list-disc space-y-1 pl-6">
              <li>
                Crear y gestionar sesiones de catacion con multiples protocolos
              </li>
              <li>
                Registrar evaluaciones sensoriales (afectivas y descriptivas)
              </li>
              <li>Documentar informacion extrinseca de muestras de cafe</li>
              <li>Gestionar organizaciones y equipos de catacion</li>
              <li>Generar reportes y analisis de catacion</li>
              <li>
                Acceder a herramientas de inteligencia artificial para analisis
                sensorial
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold">3. Cuentas de usuario</h2>
            <h3 className="text-lg font-medium">3.1 Registro</h3>
            <p>
              Para utilizar la Plataforma debes crear una cuenta proporcionando
              informacion veraz y completa. Eres responsable de mantener la
              confidencialidad de tus credenciales de acceso.
            </p>
            <h3 className="mt-4 text-lg font-medium">
              3.2 Responsabilidad de la cuenta
            </h3>
            <p>
              Eres responsable de toda la actividad que ocurra bajo tu cuenta.
              Debes notificarnos inmediatamente si sospechas de uso no
              autorizado.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold">4. Propiedad intelectual</h2>
            <h3 className="text-lg font-medium">
              4.1 Contenido de Catador Pro
            </h3>
            <p>
              La plataforma, su diseno, codigo fuente, logotipos, marcas y
              contenido original son propiedad de Catador Pro y estan protegidos
              por leyes de propiedad intelectual. No puedes reproducir,
              distribuir ni crear obras derivadas sin autorizacion.
            </p>
            <h3 className="mt-4 text-lg font-medium">4.2 Tu contenido</h3>
            <p>
              Conservas la propiedad de los datos de catacion, notas y
              evaluaciones que creas en la Plataforma. Al utilizar el servicio,
              nos otorgas una licencia limitada para almacenar, procesar y
              mostrar tu contenido con el fin de proporcionarte el servicio.
            </p>
            <h3 className="mt-4 text-lg font-medium">
              4.3 Protocolos y metodologias de catacion
            </h3>
            <p>
              Catador Pro implementa diversas metodologias de evaluacion de
              cafe. Algunos protocolos estan inspirados en estandares de la
              industria publicados por organizaciones como la Specialty Coffee
              Association (SCA). Catador Pro no es un producto oficial ni esta
              afiliado, patrocinado o respaldado por la SCA a menos que se
              indique expresamente lo contrario. Las marcas, nombres y
              estandares de terceros pertenecen a sus respectivos propietarios.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold">5. Uso aceptable</h2>
            <p>Al utilizar la Plataforma, te comprometes a:</p>
            <ul className="list-disc space-y-1 pl-6">
              <li>No utilizar el servicio para actividades ilegales</li>
              <li>
                No intentar acceder a cuentas, datos o sistemas sin autorizacion
              </li>
              <li>
                No interferir con el funcionamiento de la plataforma ni
                introducir malware
              </li>
              <li>
                No utilizar sistemas automatizados para extraer datos masivos de
                la plataforma (scraping)
              </li>
              <li>Respetar los derechos de otros usuarios y organizaciones</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold">
              6. Organizaciones y equipos
            </h2>
            <p>
              Si creas o administras una organizacion en Catador Pro, eres
              responsable de gestionar los permisos de los miembros y del
              contenido compartido dentro de la organizacion. Los datos de
              catacion creados dentro de una organizacion estan sujetos a los
              permisos y roles establecidos por el administrador.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold">
              7. Inteligencia artificial
            </h2>
            <p>
              Catador Pro integra funcionalidades de inteligencia artificial
              para asistencia en analisis sensorial. Al utilizar estas
              funcionalidades:
            </p>
            <ul className="list-disc space-y-1 pl-6">
              <li>
                Tus datos de catacion pueden ser procesados por proveedores de
                IA externos (actualmente Anthropic) para generar sugerencias y
                analisis
              </li>
              <li>
                Las sugerencias generadas por IA son orientativas y no
                sustituyen el criterio profesional del catador
              </li>
              <li>
                No garantizamos la exactitud de los resultados generados por IA
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold">
              8. Disponibilidad del servicio
            </h2>
            <p>
              Nos esforzamos por mantener la Plataforma disponible de forma
              continua, pero no garantizamos un servicio ininterrumpido. Podemos
              realizar mantenimiento, actualizaciones o suspender el servicio
              temporal o permanentemente, con o sin aviso previo.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold">
              9. Limitacion de responsabilidad
            </h2>
            <p>
              Catador Pro se proporciona &quot;tal cual&quot; y &quot;segun
              disponibilidad&quot;. En la maxima medida permitida por la ley:
            </p>
            <ul className="list-disc space-y-1 pl-6">
              <li>
                No garantizamos que la Plataforma sera libre de errores o
                interrupciones
              </li>
              <li>
                No somos responsables de perdidas de datos, lucro cesante ni
                danos indirectos derivados del uso de la Plataforma
              </li>
              <li>
                No somos responsables de decisiones comerciales tomadas con base
                en datos o analisis de la Plataforma
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold">10. Terminacion</h2>
            <p>
              Podemos suspender o cancelar tu acceso a la Plataforma en
              cualquier momento si violas estos terminos. Tu puedes cancelar tu
              cuenta en cualquier momento desde la configuracion de tu perfil.
              Al cancelar, tus datos seran tratados conforme a nuestra{" "}
              <Link href="/privacy" className="text-primary hover:underline">
                Politica de Privacidad
              </Link>
              .
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold">
              11. Legislacion aplicable
            </h2>
            <p>
              Estos terminos se rigen por las leyes de los Estados Unidos
              Mexicanos. Cualquier controversia sera resuelta ante los
              tribunales competentes de la Ciudad de Mexico.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold">12. Contacto</h2>
            <p>Para preguntas sobre estos Terminos y Condiciones:</p>
            <p>
              <strong>Catador Pro</strong>
              <br />
              Email:{" "}
              <a
                href="mailto:legal@catador.pro"
                className="text-primary hover:underline"
              >
                legal@catador.pro
              </a>
              <br />
              Sitio web: catador.pro
            </p>
          </section>
        </div>

        <div className="mt-12 border-t pt-6">
          <Link
            href="/privacy"
            className="text-primary text-sm hover:underline"
          >
            Politica de Privacidad
          </Link>
        </div>
      </div>
    </>
  )
}
